<template>
    <button class="link" @click="toggle" :class="{ 'is-active': isActive }">
        {{ item.MainLink.Text }}
        <span class="icon"></span>
    </button>
    <Transition name="expand" @enter="enter" @after-enter="afterEnter" @leave="leave">
        <div class="nav-list__sub-items" v-if="isActive">
            <a
                class="sub-link"
                :href="subitem.Url"
                :target="subitem.Target"
                :class="{ 'is-active': subitem.Active }"
                v-for="(subitem, index) in item.SubItems"
                :key="index">
                {{ subitem.Text }}
            </a>
        </div>
    </Transition>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import { INavigationLinks } from '../../../interfaces/Navigation';

defineProps<{
    item: INavigationLinks;
}>();

const isActive = ref(false);

const toggle = () => {
    isActive.value = !isActive.value;
};

const enter = (el: HTMLElement) => {
    el.style.height = 'auto';

    const height = getComputedStyle(el).height;
    el.style.height = '0';

    getComputedStyle(el);

    setTimeout(() => {
        el.style.height = height;
    });
};

const afterEnter = (el: HTMLElement) => {
    el.style.height = 'auto';
};

const leave = (el: HTMLElement) => {
    el.style.height = getComputedStyle(el).height;

    getComputedStyle(el);

    setTimeout(() => {
        el.style.height = '0';
    });
};
</script>
